import queryString from 'query-string';

import { isProduction } from '@/components/signup/utils/environment';

const LOOM_TWC_WELCOME_URL = 'https://www.loom.com/twc/welcome';
const LOOM_TWC_WELCOME_STAGING_URL = 'https://stage.loom.com/twc/welcome';

type LoomTwcWelcomeUrlOptions = {
	skipUpgrade?: boolean;
};

export const getLoomTwcWelcomeUrl = (
	siteId: string,
	{ skipUpgrade = false }: LoomTwcWelcomeUrlOptions = {},
) => {
	return queryString.stringifyUrl({
		url: isProduction() ? LOOM_TWC_WELCOME_URL : LOOM_TWC_WELCOME_STAGING_URL,
		query: {
			siteId,
			// query-string serializes null as a valueless parameter (`&skipUpgrade`).
			skipUpgrade: skipUpgrade ? null : undefined,
		},
	});
};
